<h2 mat-dialog-title class="av-section-title">{{ 'backoffice.subscriptions.trial.dialog_title' | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.subscriptions.trial.hint' | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="trial-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.subscriptions.trial.current_end' | translate }}</dt>
      <dd class="m-0 text-end" data-testid="trial-current-end">
        {{ data.currentTrialEnd || ('backoffice.subscriptions.trial.not_set' | translate) }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.subscriptions.trial.max_end' | translate }}</dt>
      <dd class="m-0 text-end" data-testid="trial-max-end">{{ data.maxTrialEnd }}</dd>
    </div>
  </dl>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="trial-end">
      <span class="av-meta">{{ 'backoffice.subscriptions.trial.end_label' | translate }}</span>
      <input
        id="trial-end"
        type="date"
        class="av-field"
        formControlName="trial_end"
        data-testid="trial-end-input"
      />
    </label>

    <label class="d-flex flex-column gap-1" for="trial-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="trial-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
        data-testid="trial-reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">{{ 'backoffice.common.actions.cancel' | translate }}</button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
    data-testid="trial-submit"
  >
    {{ 'backoffice.subscriptions.trial.submit' | translate }}
  </button>
</mat-dialog-actions>
